import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import {
  RSPCRA_Reverse,
  RSPCRB_DELETE,
  RSPCRA_RSPCRB_Update,
  RSPCRB_GetRow,
  VNDRDISB_Items_Discontinue_Status_Getrow,
  RSP_Status_GETROW,
  GET_API_RSP_Change_Request_Basket_GetRow,
} from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import { Head_Set } from "./SliceRSPChangeRequest";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  toArrayFromCSV,
} from "../../Utility/Utilitys";
import {
  DataGridPro,
  useGridApiRef,
  gridRowIdsSelector,
} from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import { fExecuteAPI } from "../../Server/Apis";
import GCAutocompleteCheckboxFixSizeUid from "../VendorDiscontinueChangeRequest/GCAutocompleteCheckboxFixSizeUid";
import RSPChange_Breadcrumbs from "./RSPChange_Breadcrumbs";
import dayjs from "dayjs";
import PromotionAutocomplete from "./proccessComponent/PromotionAutocomplete";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

// import Breadcrumbs from "./BreadCrumbs";

const RSPChangeDetail = () => {
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();

  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const isLessThanLarge = useMediaQuery("(max-width:1520px)");

  const headData = useSelector(
    (state) => state.SliceRSPChangeRequest.value.Head
  );
  const locationArr = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const competitorRedux = useSelector(
    (state) => state.SliceDB.value.Apps
  ).filter((item) => item.Grp === "RSPSC" || item.Grp === "");

  const typeOptions = [
    { id: "Market Survey", name: "Market Survey" },
    { id: "GP Correction", name: "GP Correction" },
    { id: "Dead/Slow Moving", name: "Dead/Slow Moving" },
    { id: "Near Expiry", name: "Near Expiry" },
    { id: "Aging Stock", name: "Aging Stock" },
  ];

  const initialBufferObj = {
    B_TransId: 0,
    B_Srno: 0,
    B_Itmcd: "",
    B_Unit: "",
    B_New_CostPrice: 0,
    B_Old_CostPrice: 0,
    B_Old_RSP: 0,
    B_New_RSP: 0,
    B_Old_RSPVat: 0,
    B_New_RSPVat: 0,
    B_Old_GPPerc: 0,
    B_New_GPPerc: 0,
    B_CostPrice: 0,
    B_Old_MarkupPerc: 0,
    B_New_MarkupPerc: 0,
    B_Type: "",
    B_Competitor: "",
    B_CompetitorPrice: 0, // For Market Survey
    B_PromoId: "", // For Dead/Slow Moving, Near Expiry, Aging Stock
    B_ExpireDate: new Date(), // For Near Expiry
    B_AgingDays: 0, // For Aging Stock
    B_RefDocNo: "",
    B_Vendor: "",
    B_VendorName: "",
    B_Narration: "",
    B_RejectDetail: "",
    B_RejectNarration: "",
    TaxPerc: 0,
    AddiCessAmt: 0,
    B_Stock: 0,
    PromoName: "",
  };

  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [promtionBasketOpen, setPromtionBasketOpen] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const [basketRows, setBasketRows] = useState([]);
  const [filteredBasketRows, setfilteredBasketRows] = useState([]);
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [DetailData, setDetailData] = useState([]);
  const [searchModal, setSearchModal] = useState(false);
  const [bufferObject, setBufferObj] = useState(initialBufferObj);
  const [Unit, setUnit] = useState([]);
  const [competitorArr, setCompetitorArr] = useState([]);
  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);
  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);

  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });


  const fLoadDetail = async (id) => {
    const obj = {
      B_TransId: id ? id : headData?.A_TransId,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const detailRes = await RSPCRB_GetRow(FinalObj);
    if (detailRes?.status === 200) {
      setDetailData(detailRes?.data?.ResultSet);
    }
  };

  // Item Code Item Name

  const handleDetailChange = (field, value, event = null) => {
    setBufferObj((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleItemSelection = async (ItmCd, Name1, DefUnit = "") => {
    setBufferObj((prev) => ({
      ...prev,
      B_Itmcd: ItmCd,
      ItemName: Name1,
    }));

    await GetUnitArr(ItmCd, true, DefUnit);
    setSearchModal(false);
  };

  const handleRowClick = async (selectedRow) => {
    setBufferObj((prevV) => ({
      ...prevV,
      ...selectedRow,
    }));

    await GetUnitArr(selectedRow.B_Itmcd);

    setBufferObj((prevV) => ({
      ...prevV,
      B_Unit: selectedRow.B_Unit,
    }));
  };

  const fValidationHead = () => {
    let isValid = true;
    if (headData?.A_TransId === "") {
      fAlertToast("FAILED", "Trans Id should not be empty");
      return;
    }
    if (headData?.A_Date === "") {
      fAlertToast("FAILED", "Date should not be empty");
      isValid = false;
      return;
    }
    if (headData?.A_Loc === "") {
      fAlertToast("FAILED", "Location should not be empty");
      isValid = false;
      return;
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    if (
      bufferObject.B_Itmcd === "" ||
      bufferObject.B_Itmcd == undefined ||
      bufferObject.B_Itmcd === null
    ) {
      fAlertToast("FAILED", "Item Code is required.");
      isValid = false;
      return;
    }

    if (
      bufferObject.B_Unit === "" ||
      bufferObject.B_Unit === undefined ||
      bufferObject.B_Unit === null
    ) {
      fAlertToast("FAILED", `Unit is required `);
      isValid = false;
      return;
    }
    if (
      bufferObject.B_Type === "" ||
      bufferObject.B_Type === undefined ||
      bufferObject.B_Type === null
    ) {
      fAlertToast("FAILED", `Type is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.B_New_RSP === 0 ||
      bufferObject.B_New_RSP === undefined ||
      bufferObject.B_New_RSP === null
    ) {
      fAlertToast("FAILED", `New RSP is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.B_New_RSPVat === 0 ||
      bufferObject.B_New_RSPVat === undefined ||
      bufferObject.B_New_RSPVat === null
    ) {
      fAlertToast("FAILED", `New RSP Vat is required `);
      isValid = false;
      return;
    }
    if (
      bufferObject.B_New_GPPerc === 0 ||
      bufferObject.B_New_GPPerc === undefined ||
      bufferObject.B_New_GPPerc === null
    ) {
      fAlertToast("FAILED", `New GP  Percentage is required `);
      isValid = false;
      return;
    }
    if (
      bufferObject.B_New_MarkupPerc === 0 ||
      bufferObject.B_New_MarkupPerc === undefined ||
      bufferObject.B_New_MarkupPerc === null
    ) {
      fAlertToast("FAILED", `New Markup Percentage is required `);
      isValid = false;
      return;
    }
    // ---- Type specific validations ----
    if (bufferObject.B_Type === "Market Survey") {
      if (!bufferObject.B_Competitor) {
        fAlertToast("FAILED", "Competitor is required");
        isValid = false;
        return;
      }
      if (
        !bufferObject.B_CompetitorPrice ||
        Number(bufferObject.B_CompetitorPrice) <= 0
      ) {
        fAlertToast("FAILED", "Competitor Price is required");
        isValid = false;
        return;
      }
    }

    if (bufferObject.B_Type === "Dead/Slow Moving") {
      if (!bufferObject.B_PromoId) {
        fAlertToast("FAILED", "Promotion Basket ID is required");
        isValid = false;
        return;
      }
      if (!bufferObject.B_Stock || Number(bufferObject.B_Stock) <= 0) {
        fAlertToast("FAILED", "Stock is required");
        isValid = false;
        return;
      }
    }

    if (bufferObject.B_Type === "Near Expiry") {
      if (!bufferObject.B_ExpireDate) {
        fAlertToast("FAILED", "Expiry Date is required");
        isValid = false;
        return;
      }
      if (!bufferObject.B_PromoId) {
        fAlertToast("FAILED", "Promotion Basket ID is required");
        isValid = false;
        return;
      }
      if (!bufferObject.B_Stock || Number(bufferObject.B_Stock) <= 0) {
        fAlertToast("FAILED", "Stock is required");
        isValid = false;
        return;
      }
    }

    if (bufferObject.B_Type === "Aging Stock") {
      if (!bufferObject.B_AgingDays || Number(bufferObject.B_AgingDays) <= 0) {
        fAlertToast("FAILED", "Aging Days is required");
        isValid = false;
        return;
      }
      if (!bufferObject.B_PromoId) {
        fAlertToast("FAILED", "Promotion Basket ID is required");
        isValid = false;
        return;
      }
      if (!bufferObject.B_Stock || Number(bufferObject.B_Stock) <= 0) {
        fAlertToast("FAILED", "Stock is required");
        isValid = false;
        return;
      }
    }

    return isValid;
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: 0,
      }));
    }
  };
  const { UserID } = vRdxUserInfo() || {};

  const fSave = async (isApproved, name) => {
    if (!fValidationHead()) return;
    let items;
    if (!isApproved) {
      if (!fValidationDetail()) return;
      items = [
        {
          ...bufferObject,
          B_ExpireDate:
            bufferObject.B_Type === "Near Expiry"
              ? dayjs(bufferObject.B_ExpireDate).format("MM/DD/YYYY")
              : "01/01/1900",
        },
      ];
    } else {
      if (DetailData?.length === 0) {
        fAlertToast("FAILED", "Save at least one line item");
        return;
      }

      items = DetailData;
    }

    const requestPayload = {
      A_TransId: headData?.A_TransId,
      A_Date: moment(headData?.A_Date).format("MM/DD/YYYY"),
      A_Loc: headData?.A_Loc,
      A_Narration: headData?.A_Narration,
      A_UserCd: UserID,
      DeleteInsert: "N",
      Items: items,
      isApproved,
      A_LocCSV: headData?.A_LocCSV,
    };

    const res = await RSPCRA_RSPCRB_Update(requestPayload);

    if (res?.status === 200) {
      fAlertToast("SUCCESS", `${name} Successfully`);
      dispatch(
        Head_Set({
          ...headData,
          A_TransId: res.data?.ResultSet?.[0]?.A_TransId,
          A_Status: name === "Approved" ? "POST" : headData.A_Status,
          A_Confirm_Status:
            name === "Approved" ? "ENTER" : headData.A_Confirm_Status,
        })
      );
      fNewDetail(res.data?.ResultSet?.[0]?.A_TransId);
    }
  };

  const handleDelete = async (row) => {
    var obj = {
      B_TransId: row?.B_TransId,
      B_Srno: row?.B_Srno,
    };

    const transDelete = await RSPCRB_DELETE(obj);
    if (transDelete?.status === 200) {
      fAlertToast("SUCCESS", "Deleted Successfully");
      fNewDetail(row?.B_TransId);
    }
  };

  const fNewHead = () => {
    // dispatch(Head_Set({ ...headData, ...initialHeadObj }));
    fNewDetail();
  };

  const fNewDetail = async (id) => {
    setBufferObj(initialBufferObj);
    setUnit([]);
    const itemNameInput = document.querySelector('[tabindex="1"]');
    if (itemNameInput) {
      itemNameInput.focus();
    }
    await fLoadDetail(id);
  };

  const columnGroupingModel = [
    {
      groupId: "Old",
      headerAlign: "center",
      align: "center",
      children: [
        { field: "B_Old_RSP" },
        { field: "B_Old_RSPVat" },
        { field: "B_Old_GPPerc" },
        { field: "B_Old_MarkupPerc" },
      ],
    },
    {
      groupId: "New",
      headerAlign: "center",
      align: "center",
      children: [
        { field: "B_New_RSP" },
        { field: "B_New_RSPVat" },
        { field: "B_New_GPPerc" },
        { field: "B_New_MarkupPerc" },
      ],
    },
  ];

  const fLoadItemDetail = async (ItmCd) => {
    try {
      const obj = {
        Barcode: "",
        Vendor: bufferObject?.B_Vendor,
        ItmCd: ItmCd ? ItmCd : bufferObject?.B_Itmcd,
        Loc: headData?.A_Loc,
      };
      const response = await VNDRDISB_Items_Discontinue_Status_Getrow(obj);
      if (response?.status === 200) {
        if (response?.data?.ResultSet.length > 0) {
          setBufferObj((prevV) => ({
            ...prevV,
            Old_DisContinued: response?.data?.ResultSet[0]?.DisContinued,
            New_DisContinued: response?.data?.ResultSet[0]?.DisContinued,
          }));
        } else {
          setBufferObj((prevV) => ({
            ...prevV,
            Old_DisContinued: "N",
            New_DisContinued: "N",
          }));
        }
        return response?.data?.ResultSet;
      }
    } catch (error) {}
  };

  //vendor start

  //2nd call
  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: bufferObject.B_VendorName,
      }));
      if (bufferObject.B_VendorName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          bufferObject.B_VendorName,
          "Any",
          "C",
          "N",
          headData.A_Loc
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };

  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);

      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  const fOnKeyUpVendor = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        bufferObject.B_VendorName,
        "Any",
        "C",
        "Y",
        headData.A_Loc
      );
      if (vExactSearch.length > 0) {
        dispatch(
          Head_Set({
            ...headData,
            VendorCd: vExactSearch[0]?.AcCd,
            B_VendorName: vExactSearch[0]?.Name1,
          })
        );
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
    }
    if (e.key === "Backspace" && bufferObject.B_Vendor) {
      setBufferObj((prev) => ({
        ...prev,
        B_Vendor: "",
        B_VendorName: "",
      }));
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        "C",
        "N",
        dispatch
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const Get_ToggleDropDown_Load = async (
    xData = bufferObject?.B_VendorName,
    xType = "Any",
    xAcTyp = "C",
    xExact = "Y",
    A_Loc = headData.A_Loc
  ) => {
    let vLoaded_Cost_FreightObj = {
      Data: xData,
      Type: xType,
      Loc: A_Loc,
      AcTyp: xAcTyp,
      Exact: xExact,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
    const vLandedCostDropdownSearch = await fExecuteAPI(
      "AccountTransSearch_GETROW",
      FinalObj
    );
    if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
      let GridID = [];
      if (vLandedCostDropdownSearch.ResultSet.length > 0) {
        let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        return GridID;
      } else {
        return GridID;
      }
    } else {
      fAlertToast("FAILED", "Error in loading LandedCost Api");
      return [];
    }
  };
  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGC_Toggle_Head_Customer_ToggleDropDowm(false);
        }
      }

      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm, sItemToggleDropdown]);

  //vendor end
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        bufferObject?.ItemName,
        headData?.A_Loc
      );
      if (vItemSearchFull.length > 0) {
        handleItemSelection(
          vItemSearchFull[0]?.ItmCd,
          vItemSearchFull[0]?.Name1,
          vItemSearchFull[0]?.DefUnit
        );
        setItemToggleDropdown(false);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace" && bufferObject?.B_Itmcd) {
      setBufferObj((prev) => ({
        ...prev,
        B_Itmcd: "",
        ItemName: "",
      }));
    }
  };

  const fPromotionSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setPromtionBasketOpen(true);
    }
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        headData?.A_Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const fGCToggleItemOnRowClick = async (e) => {
    handleItemSelection(e?.row?.ItmCd, e?.row?.Name1, "");
    setItemToggleDropdown(false);
  };

  const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
    let vSeatchVendor = {
      Data: xData,
      Type: xType,
      Loc: xA_Loc,
    };
    const vItemSearch = await fExecuteAPI(
      "SEARCHITEM001_GETROW",
      vSeatchVendor
    );
    if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
      let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(vItemSearchArr);
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch.response.data.message
          ? vItemSearch.response.data.message
          : "Error in SearchItem"
      );
    }
  };
  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      // "ITEM_SEARCHFULL_GETROW",
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    //status code "" so Success is checked
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet?.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  }, [sItemToggleDropdown]);

  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: bufferObject?.ItemName,
    }));

    if (bufferObject?.ItemName != "") {
      GetSearchItem(
        bufferObject?.ItemName,
        "Any",
        headData?.A_Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const reverseSave = async () => {
    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;
    const obj = {
      A_TransId: headData?.A_TransId,
      UserCd: vRdxUserInfo()?.UserID,
      A_Typ: "",
    };
    const reverseRes = await RSPCRA_Reverse(obj);
    if (reverseRes?.status === 200) {
      fAlertToast("SUCCESS", "Reversed Successfully");
      dispatch(
        Head_Set({
          ...headData,
          A_Status: "ENTER",
          A_StatusCM: "ENTER",
        })
      );
    } else {
      fAlertToast("FAILED", "Reverse Failed");
    }
  };

  const GetUnitArr = async (xItemCode, loaderScreen = true, defUnit) => {
    try {
      const response = await fExecuteAPI(
        "GETITEMUNITS_GETROW",
        { itemCd: xItemCode },
        loaderScreen
      );

      if (response?.Type?.toUpperCase() !== "SUCCESS") {
        throw new Error(
          response?.Type?.response?.data?.message ||
            response?.message ||
            response?.response?.data?.Status ||
            "Error in fetching units"
        );
      }

      const units = response.ResultSet || [];
      if (units.length === 0) return [];

      setUnit(units);
      const unitInput = document.querySelector('[tabindex="2"]');
      if (unitInput) {
        unitInput.focus();
      }
      // const defaultUnit = units[0]?.Unit;
      // setBufferObj((prev) => ({ ...prev, B_Unit: defaultUnit }));
      const defaultUnit = defUnit || units[0]?.Unit;
      setBufferObj((prev) => ({ ...prev, B_Unit: defaultUnit }));
      await getCostPrice(xItemCode, defaultUnit);
      return units;
    } catch (error) {
      fAlertToast("FAILED", error.message);
      return [];
    }
  };

  const getCostPrice = async (itemCd, unitId) => {
    try {
      const response = await RSP_Status_GETROW({
        ItmCd: itemCd,
        UnitId: unitId,
        Loc: headData?.A_Loc,
      });

      if (response?.data?.Type?.toUpperCase() !== "SUCCESS") {
        throw new Error(response?.message || "Error in fetching Cost Price");
      }

      const obj = response.data?.ResultSet[0];

      setBufferObj((prev) => ({
        ...prev,
        B_Old_RSP: obj?.RSP?.toFixed(2),
        B_Old_RSPVat: obj?.VATRSP?.toFixed(2),
        B_Old_GPPerc: obj?.GPPerc?.toFixed(2),
        B_CostPrice: obj?.CostPr?.toFixed(2),
        B_Old_MarkupPerc: obj?.MarkupPerc?.toFixed(2),
        AddiCessAmt: obj?.AddiCessAmt?.toFixed(2),
        TaxPerc: obj?.TaxPerc?.toFixed(2),
      }));
    } catch (error) {
      fAlertToast("FAILED", error.message);
    }
  };

  const handleBasketRowClick = (params) => {
    setBufferObj((prev) => ({
      ...prev,
      B_PromoId: params?.row?.PromoId,
      PromoName: params?.row?.Narration,
    }));
    setPromtionBasketOpen(false);
    setTimeout(() => {
      const stockInput = document.querySelector('[tabindex="11"]');
      if (stockInput) {
        stockInput.focus();
      }
    }, 1000);
  };

  const getBasketRows = async () => {
    try {
      const res = await GET_API_RSP_Change_Request_Basket_GetRow();
      if (res?.status === 200) {
        setBasketRows(res?.data?.ResultSet || []);
        setfilteredBasketRows(res?.data?.ResultSet || []);
      }
    } catch (error) {}
  };

  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const headSelectedLocation = useMemo(() => {
    return toArrayFromCSV(headData?.A_LocCSV);
  }, [headData?.A_LocCSV]);


    useEffect(() => {
      setCompetitorArr(competitorRedux);
      setBufferObj(initialBufferObj);
      fLoadDetail();
      getBasketRows();
      const itemNameInput = document.querySelector('[tabindex="1"]');
      if (itemNameInput) {
        itemNameInput.focus();
      }
    }, []);
    

  return (
    <Box sx={{ mx: 1 }}>
      <RSPChange_Breadcrumbs />
      <Grid
        container
        spacing={{ xs: 1, md: 1.5 }}
        sx={{
          alignItems: { xs: "flex-start", sm: "flex-end" },
          marginTop:"12px !important",
          mb:3,
          p:2,
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          backgroundColor: "rgba(247, 249, 252, 1)",
        }}
      >
        {/* Trans ID */}
        <Grid item xs={12} sm={3} md={1.5}>
          <Typography>Trans ID</Typography>

          <TextField
            type="number"
            size="small"
            value={headData?.A_TransId}
            fullWidth
            sx={{
              bgcolor: "lightgray",
            }}
            tabIndex={-1}
          />
        </Grid>

        {/* Trans Date */}
        <Grid item xs={12} sm={4} md={2}>
          <Typography>Trans Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName="A_Date"
            xValue={headData?.A_Date}
            xOnChange={(newValue) =>
              dispatch(Head_Set({ ...headData, A_Date: newValue?.$d ?? newValue }))
            }
          />
        </Grid>

        {/* Trans Location */}
        <Grid item xs={12} sm={5} md={2.5}>
          <Typography>Trans Location</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={headData?.A_Loc}
              name="A_Loc"
              onChange={(e) =>
                dispatch(Head_Set({ ...headData, A_Loc: e.target.value }))
              }
            >
              {locationArr?.map((loc) => (
                <MenuItem key={loc.Uid} value={loc.Uid}>
                  {loc?.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Location Multi-select */}
        <Grid item xs={12} sm={6} md={2.5}>
          <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            xLabelText="Location"
            xValue={headData?.A_LocCSV}
            setValue={(updated) => {
              dispatch(Head_Set({ ...headData, A_LocCSV: updated }));
            }}
            options={locationArr ?? []}
            objName="location"
            placeholder="Search Location"
          />
        </Grid>

        {/* Narration */}
        <Grid item xs={12} sm={6} md={3.5}>
          <Typography>Narration</Typography>
          <TextField
            size="small"
            value={headData?.A_Narration}
            name="A_Narration"
            onChange={(e) =>
              dispatch(Head_Set({ ...headData, A_Narration: e.target.value }))
            }
            fullWidth
            autoComplete="off"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={{ xs: 1, md: 1.5 }}
        sx={{
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          backgroundColor: "white",
          padding: "5px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={3}
          md={1.5}
          lg={isLessThanLarge ? 1.5 : 1}
          sx={{
            paddingLeft: {
              xs: "13px !important",
              sm: "13px !important",
              md: "12px !important",
              lg: "12px !important",
            },
          }}
        >
          <Typography>Item Code</Typography>
          <TextField
            value={bufferObject?.B_Itmcd}
            onChange={(e) => handleDetailChange("B_Itmcd", e.target.value, e)}
            sx={{
              bgcolor: "lightgray",
              "& .MuiInputBase-root": {
                padding: 0, // Removes outer padding
              },
              "& .MuiInputBase-input": {
                padding: "8.5px 11px", // Removes inner input padding
              },
            }}
            fullWidth
            disabled
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4.5} lg={4}>
          <Typography>Item Name</Typography>
          <GCToggleSearchV1
            xLabelText=""
            xtabIndex="1"
            xName="B_ItmName"
            xType="text"
            xValue={bufferObject?.ItemName}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((prev) => ({
                ...prev,
                B_Itmcd: "",
                B_Unit: "",
                B_CostPrice: 0,
                B_Old_GPPerc: 0,
                B_Old_MarkupPerc: 0,
                B_Old_RSP: 0,
                B_Old_RSPVat: 0,
                B_New_CostPrice: 0,
                B_New_GPPerc: 0,
                B_New_MarkupPerc: 0,
                B_New_RSP: 0,
                B_New_RSPVat: 0,
              }));
              setUnit([]);
              handleDetailChange("ItemName", e.target.value);
            }}
            xOnKeyUp={fItemSearchKey}
            xonClickbtn={fItemSearchKey}
            xrows={sGridSelectRowData}
            xcolumns={[
              { field: "id", headerName: "ID", width: 70, hide: true },
              { field: "ItmCd", headerName: "Code", width: 90 },
              { field: "Name1", headerName: "Name", flex: 1 },
            ]}
            xRowClick={fGCToggleItemOnRowClick}
            xRowCellClick={fGCToggleItemOnCellKeyDown}
            xToggle={sItemToggleDropdown}
            xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
            xOnChangeDropdownInput={fOnChangeItem}
            xDropdownObj={sItemSearchDropdownObj}
            xOnKeyUpDropdownInput={fOnKeyUpItem}
          />
        </Grid>{" "}
        <Grid item xs={12} sm={5} md={2} lg={1.5}>
          <Typography>Unit</Typography>

          <FormControl fullWidth>
            <Select
              size="small"
              value={bufferObject?.B_Unit}
              name="B_Unit"
              onChange={(e) => {
                setBufferObj((prevV) => ({
                  ...prevV,
                  B_Unit: e.target.value,
                }));
                getCostPrice(bufferObject?.B_Itmcd, e.target.value);
              }}
              // inputRef={unitRef}
              autoComplete="off"
              inputProps={{
                tabIndex: 2,
              }}
            >
              {Unit.map((val) => (
                <MenuItem key={val.UOM} value={val.UOM}>
                  {val?.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4} sm={2} md={1.5} lg={isLessThanLarge ? 1 : 0.8}>
          <Typography> Cost Price</Typography>
          <TextField
            type="number"
            size="small"
            value={bufferObject?.B_CostPrice}
            disabled
            onChange={(e) =>
              setBufferObj((prev) => ({
                ...prev,
                B_CostPrice: e.target.value,
              }))
            }
            fullWidth
            sx={{
              width: 60,
              bgcolor: "lightgray",
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
            tabIndex={-1}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2.4}
          md={1}
          lg={isLessThanLarge ? 1 : 0.75}
          sx={{
            paddingLeft: {
              xs: "5px !important",
              sm: "1px !important",
              md: "0px !important",
              lg: "5px !important",
            },
          }}
        >
          {" "}
          <Typography>Old RSP</Typography>
          <TextField
            size="small"
            type="number"
            value={bufferObject?.B_Old_RSP}
            disabled
            sx={{
              width: 60,
              bgcolor: "lightgray",
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
            tabIndex={-1}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1.5}
          lg={isLessThanLarge ? 1 : 0.85}
          sx={{
            paddingLeft: {
              xs: "5px !important",
              sm: "1px !important",
              md: "15px !important",
              lg: "5px !important",
            },
          }}
        >
          <Typography>Old VAT RSP</Typography>
          <TextField
            size="small"
            type="number"
            value={bufferObject?.B_Old_RSPVat}
            disabled
            tabIndex={-1}
            sx={{
              width: 60,
              bgcolor: "lightgray",
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2.8}
          md={1.5}
          lg={isLessThanLarge ? 1 : 0.75}
          sx={{
            paddingLeft: {
              xs: "12px !important",
              sm: "2px !important",
              md: "13px !important",
              lg: "5px !important",
            },
          }}
        >
          <Typography>Old GP % </Typography>
          <TextField
            size="small"
            type="number"
            value={bufferObject?.B_Old_GPPerc}
            tabIndex={-1}
            disabled
            sx={{
              width: 60,
              bgcolor: "lightgray",
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          lg={isLessThanLarge ? 1 : 0.95}
          sx={{
            paddingLeft: {
              xs: "5px !important",
              sm: "5px !important",
              md: "13px !important",
              lg: "5px !important",
            },
          }}
        >
          <Typography>Old Markup %</Typography>
          <TextField
            size="small"
            type="number"
            value={bufferObject?.B_Old_MarkupPerc}
            disabled
            fullWidth
            tabIndex={-1}
            sx={{
              // width: 60,
              bgcolor: "lightgray",
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1.5} lg={isLessThanLarge ? 1 : 0.75}>
          {" "}
          <Typography>New RSP</Typography>
          <TextField
            size="small"
            type="number"
            name="B_New_RSP"
            value={bufferObject?.B_New_RSP}
            onChange={(e) => {
              const rsp = parseFloat(e.target.value);
              const cost = parseFloat(bufferObject.B_CostPrice);
              const taxPerc = parseFloat(bufferObject.TaxPerc);
              const addiCess = parseFloat(bufferObject.AddiCessAmt);

              // Correct VAT and VAT-inclusive RSP calculation
              const vatAmount = rsp * (taxPerc / 100);
              const rspWithVAT = rsp + vatAmount + addiCess;

              // GP% and Markup%
              const gpPerc = rsp === 0 ? 0 : ((rsp - cost) / rsp) * 100;
              const markupPerc = cost === 0 ? 0 : ((rsp - cost) / cost) * 100;

              setBufferObj((prev) => ({
                ...prev,
                B_New_RSP: rsp, // VAT-exclusive rsp,
                B_New_RSPVat: parseFloat(rspWithVAT)?.toFixed(2), // VAT-inclusive
                B_New_GPPerc: parseFloat(gpPerc)?.toFixed(2),
                B_New_MarkupPerc: parseFloat(markupPerc)?.toFixed(2),
              }));
            }}
            onFocus={fContent_Focus}
            onBlur={fContent_Blur}
            sx={{
              width: 60,

              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
            inputProps={{
              tabIndex: 3,
              min: 0,
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={3}
          md={1.5}
          lg={isLessThanLarge ? 1 : 0.95}
          sx={{
            paddingLeft: {
              xs: "13px !important",
              sm: "13px !important",
              md: "0px !important",
              lg: "12px !important",
            },
          }}
        >
          <Typography> New VAT RSP</Typography>
          <TextField
            size="small"
            type="number"
            value={bufferObject?.B_New_RSPVat}
            onChange={(e) => {
              const vatRSP = parseFloat(e.target.value);
              const taxPerc = parseFloat(bufferObject.TaxPerc);
              const cost = parseFloat(bufferObject.B_CostPrice);
              const addiCess = parseFloat(bufferObject.AddiCessAmt);

              // RSP (without VAT and AddiCess)
              const rsp = parseFloat((vatRSP - addiCess) / (1 + taxPerc / 100));

              // GP% = (RSP - Cost) / RSP
              const gpPerc = rsp === 0 ? 0 : ((rsp - cost) / rsp) * 100;

              // Markup% = (RSP - Cost) / Cost
              const markupPerc = cost === 0 ? 0 : ((rsp - cost) / cost) * 100;

              setBufferObj((prev) => ({
                ...prev,
                B_New_RSPVat: vatRSP,
                B_New_RSP: parseFloat(rsp)?.toFixed(4),
                B_New_GPPerc: parseFloat(gpPerc)?.toFixed(2),
                B_New_MarkupPerc: parseFloat(markupPerc)?.toFixed(2),
              }));
            }}
            sx={{
              width: 60,
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
            inputProps={{
              tabIndex: 4,
              min: 0,
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={3}
          md={1.5}
          lg={isLessThanLarge ? 1 : 0.75}
          sx={{
            paddingLeft: {
              xs: "5px !important",
              sm: "13px !important",
              md: "5px !important",
              lg: "5px !important",
            },
          }}
        >
          <Typography>New GP %</Typography>
          <TextField
            size="small"
            type="number"
            value={bufferObject?.B_New_GPPerc}
            onChange={(e) =>
              setBufferObj((prev) => ({
                ...prev,
                B_New_GPPerc: e.target.value,
              }))
            }
            disabled
            tabIndex={-1}
            sx={{
              width: 60,
              bgcolor: "lightgray",
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={3}
          md={1.5}
          lg={isLessThanLarge ? 1 : 0.95}
          sx={{
            paddingLeft: "5px !important",
          }}
        >
          <Typography>NewMarkup %</Typography>
          <TextField
            size="small"
            type="number"
            value={bufferObject?.B_New_MarkupPerc}
            onChange={(e) =>
              setBufferObj((prev) => ({
                ...prev,
                B_New_MarkupPerc: e.target.value,
              }))
            }
            disabled
            tabIndex={-1}
            sx={{
              width: 60,
              bgcolor: "lightgray",
              "& .MuiInputBase-input": {
                textAlign: "center",
              },
              paddingLeft: "6px",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2} lg={2}>
          <Typography>Ref Doc NO</Typography>
          <TextField
            size="small"
            value={bufferObject?.B_RefDocNo}
            name="B_RefDocNo"
            onChange={(e) =>
              setBufferObj((prev) => ({
                ...prev,
                B_RefDocNo: e.target.value,
              }))
            }
            fullWidth
            autoComplete="off"
            inputProps={{
              tabIndex: 5,
            }}
          />
        </Grid>{" "}
        <Grid item xs={12} sm={8} md={3} lg={2.5}>
          <Typography>Vendor</Typography>
          <GCToggleSearchV1
            xLabelText=""
            xName="Vendor"
            xType="text"
            xValue={bufferObject?.B_VendorName}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((prev) => ({
                ...prev,
                B_VendorName: e.target.value,
              }));
              setGC_Toggle_Head_Customer_ToggleDropDowm(false);
            }}
            xOnKeyUp={fOnKeyUpVendor}
            xonClickbtn={fOnKeyUpVendor}
            xrows={sGC_Toggle_Head_Customer_GridData}
            xcolumns={[
              { field: "id", headerName: "ID", width: 70, hide: true },
              { field: "AcCd", headerName: "Code", width: 100 },
              { field: "Name1", headerName: "Name", flex: 1 },
            ]}
            xRowClick={(e) => {
              setBufferObj((prev) => ({
                ...prev,
                B_Vendor: e?.row?.AcCd,
                B_VendorName: e?.row?.Name1,
              }));
              xfGC_Toggle_Head_Customer_Toggle();
              setGC_Toggle_Head_Customer_ToggleDropDowm(false);
            }}
            xToggle={sGC_Toggle_Head_Customer_ToggleDropDowm}
            xData={["Any", "Code", "Name"]}
            xOnChangeDropdownInput={(e) => {
              setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
                ...obj,
                [e.target.name]: e.target.value,
              }));
            }}
            xDropdownObj={sGC_Toggle_Head_Customer_SearchDropdownObj}
            xOnKeyUpDropdownInput={
              fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
            }
            xtabIndex="6"
          />
        </Grid>{" "}
        <Grid item xs={12} sm={8} md={3.5} lg={2}>
          <Typography>Narration</Typography>
          <TextField
            size="small"
            value={bufferObject?.B_Narration}
            name="B_Narration"
            onChange={(e) =>
              setBufferObj((prev) => ({
                ...prev,
                B_Narration: e.target.value,
              }))
            }
            fullWidth
            autoComplete="off"
            inputProps={{
              tabIndex: 7,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2} lg={1.5}>
          <Typography>Type</Typography>
          <FormControl fullWidth>
            <Select
              displayEmpty
              size="small"
              value={bufferObject?.B_Type}
              name="B_Type"
              onChange={(e) => {
                setBufferObj((prevV) => ({
                  ...prevV,
                  B_Type: e.target.value,
                  B_Competitor: "",
                  B_CompetitorPrice: 0,
                  B_AgingDays: 0,
                  B_ExpireDate: new Date(),
                  B_PromoId: "",
                }));
                setTimeout(() => {
                  if (e.target.value === "Market Survey") {
                    const CompetitorDropdown =
                      document.querySelector('[tabindex="9"]');
                    if (CompetitorDropdown) {
                      CompetitorDropdown.click();
                    }
                  } else if (e.target.value === "Dead/Slow Moving") {
                    const input = document.querySelector(
                      '[tabindex="9"] input'
                    );
                    if (input) {
                      input.focus();
                    }
                  } else if (e.target.value === "Near Expiry") {
                    const expireDate = document.querySelector('[tabindex="9"]');
                    if (expireDate) {
                      expireDate.focus();
                    }
                  } else if (e.target.value === "Aging Stock") {
                    const agingStock = document.querySelector(
                      '[tabindex="9"] input'
                    );
                    if (agingStock) {
                      agingStock.focus();
                    }
                  }
                }, 1000);
              }}
              renderValue={(selected) =>
                selected
                  ? typeOptions.find((x) => x.id === selected)?.name
                  : "Select Type"
              }
              inputProps={{
                tabIndex: 8,
              }}
            >
              {typeOptions.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Conditional fields */}
        {bufferObject?.B_Type === "Market Survey" && (
          <>
            {/* Competitor */}
            <Grid item xs={12} sm={6} md={1.5}>
              <Typography>Competitor</Typography>
              <FormControl size="small" fullWidth>
                <Select
                  displayEmpty
                  value={bufferObject.B_Competitor || ""}
                  onChange={(e) => {
                    setBufferObj((prev) => ({
                      ...prev,
                      B_Competitor: e.target.value,
                    }));
                    setTimeout(() => {
                      const costPriceInput =
                        document.querySelector("[tabindex='10']");
                      if (costPriceInput) costPriceInput.focus();
                    }, 1000);
                  }}
                  renderValue={(selected) =>
                    selected
                      ? competitorArr?.find((x) => x.UId === selected)?.Name1
                      : "Select Competitor"
                  }
                  inputProps={{
                    tabIndex: 9,
                  }}
                >
                  {competitorArr?.map((opt) => (
                    <MenuItem key={opt.UId} value={opt.UId}>
                      {opt.Name1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Competitor Price */}
            <Grid item xs={12} sm={6} md={1.5}>
              <Typography>Competitor Price</Typography>
              <TextField
                size="small"
                type="number"
                fullWidth
                value={bufferObject.B_CompetitorPrice || ""}
                inputProps={{ tabIndex: 10 }}
                onChange={(e) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    B_CompetitorPrice: e.target.value,
                  }))
                }
              />
            </Grid>
          </>
        )}
        {bufferObject?.B_Type === "Dead/Slow Moving" && (
          <>
            <Grid item xs={12} sm={4} md={1}>
              <Typography>Promotion ID</Typography>

              <TextField
                type="number"
                size="small"
                value={bufferObject?.B_PromoId}
                fullWidth
                sx={{
                  bgcolor: "lightgray",
                }}
                tabIndex={-1}
              />
            </Grid>{" "}
            <Grid item xs={12} sm={6} md={2.5}>
              <Typography>Promotion Basket </Typography>
              <PromotionAutocomplete
                xValue={bufferObject?.PromoName}
                xOpen={promtionBasketOpen}
                xRows={filteredBasketRows}
                xRowsOrginal={basketRows}
                updateRows={setfilteredBasketRows}
                getBasketRows={getBasketRows}
                xModalfullScreen={vMediaQuery}
                xModalHeight={vMediaQuery ? "100vh" : "65vh"}
                vMediaQuery={vMediaQuery}
                xCloseModal={() => setPromtionBasketOpen(false)}
                xHeadSelectedLoc={headSelectedLocation}
                xOnChange={(value) => {
                  handleDetailChange("PromoName", value);
                }}
                xRowClick={(params) => {
                  handleBasketRowClick(params);
                  setTimeout(() => {
                    const wrapper = document.querySelector('[tabindex="10"]');
                    const stockInput = wrapper?.querySelector(
                      "input.MuiInputBase-input"
                    );
                    stockInput?.focus();
                  }, 1000);
                }}
                xOnKeyUp={fPromotionSearchKey}
                xonClickbtn={fPromotionSearchKey}
                xLocation={locationArr}
                xtabIndex={9}
                xOnKeyDown={(e) => {
                  if (
                    e.key === "Backspace" &&
                    (e.currentTarget.value ?? "").length <= 1
                  ) {
                    setBufferObj((prev) => ({
                      ...prev,
                      B_PromoId: "",
                      PromoName: e.target.value,
                    }));
                  }
                }}
              />
            </Grid>{" "}
            <Grid item xs={4} sm={2} md={isLessThanLarge ? 1 : 0.8}>
              <Typography> Stock</Typography>
              <TextField
                type="number"
                size="small"
                name="B_Stock"
                value={bufferObject?.B_Stock}
                onChange={(e) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    B_Stock: e.target.value,
                  }))
                }
                fullWidth
                sx={{
                  width: 60,

                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                }}
                tabIndex={10}
                onFocus={fContent_Focus}
                onBlur={fContent_Blur}
              />
            </Grid>
          </>
        )}
        {bufferObject?.B_Type === "Near Expiry" && (
          <>
            <Grid item xs={12} sm={6} md={1.5}>
              <Typography>Expiry Date</Typography>

              <CmpDatePickerField001V1
                xLabelText=""
                xName="B_ExpireDate"
                xValue={bufferObject.B_ExpireDate}
                xOnChange={(newValue) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    B_ExpireDate: newValue,
                  }))
                }
                xtabIndex={9}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <Typography>Promotion ID</Typography>

              <TextField
                type="number"
                size="small"
                value={bufferObject?.B_PromoId}
                fullWidth
                sx={{
                  bgcolor: "lightgray",
                }}
                tabIndex={-1}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.5}>
              <Typography>Promotion Basket </Typography>
              <PromotionAutocomplete
                xValue={bufferObject?.PromoName}
                xOpen={promtionBasketOpen}
                xRows={filteredBasketRows}
                xRowsOrginal={basketRows}
                updateRows={setfilteredBasketRows}
                getBasketRows={getBasketRows}
                xModalfullScreen={vMediaQuery}
                xModalHeight={vMediaQuery ? "100vh" : "65vh"}
                vMediaQuery={vMediaQuery}
                xCloseModal={() => setPromtionBasketOpen(false)}
                xHeadSelectedLoc={headSelectedLocation}
                xOnChange={(value) => {
                  handleDetailChange("PromoName", value);
                }}
                xOnKeyUp={fPromotionSearchKey}
                xonClickbtn={fPromotionSearchKey}
                xRowClick={(params) => {
                  handleBasketRowClick(params);
                  setTimeout(() => {
                    const wrapper = document.querySelector('[tabindex="11"]');
                    const stockInput = wrapper?.querySelector(
                      "input.MuiInputBase-input"
                    );
                    stockInput?.focus();
                  }, 1000);
                }}
                xLocation={locationArr}
                xtabIndex={10}
                xOnKeyDown={(e) => {
                  if (
                    e.key === "Backspace" &&
                    (e.currentTarget.value ?? "").length <= 1
                  ) {
                    setBufferObj((prev) => ({
                      ...prev,
                      B_PromoId: "",
                      PromoName: e.target.value,
                    }));
                  }
                }}
              />
            </Grid>{" "}
            <Grid item xs={4} sm={3} md={isLessThanLarge ? 1 : 0.8}>
              <Typography> Stock</Typography>
              <TextField
                type="number"
                size="small"
                name="B_Stock"
                value={bufferObject?.B_Stock}
                onChange={(e) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    B_Stock: e.target.value,
                  }))
                }
                fullWidth
                onFocus={fContent_Focus}
                onBlur={fContent_Blur}
                sx={{
                  width: 60,
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                }}
                tabIndex={11}
              />
            </Grid>
          </>
        )}
        {bufferObject?.B_Type === "Aging Stock" && (
          <>
            <Grid item xs={12} sm={3} md={1}>
              <Typography>Aging Days</Typography>
              <TextField
                size="small"
                fullWidth
                value={bufferObject.B_AgingDays || ""}
                onChange={(e) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    B_AgingDays: e.target.value,
                  }))
                }
                tabIndex={9}
              />
            </Grid>{" "}
            <Grid item xs={12} sm={6} md={1}>
              <Typography>Promotion ID</Typography>

              <TextField
                type="number"
                size="small"
                value={bufferObject?.B_PromoId}
                fullWidth
                sx={{
                  bgcolor: "lightgray",
                }}
                tabIndex={-1}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={2.5}>
              <Typography>Promotion Basket </Typography>
              <PromotionAutocomplete
                xValue={bufferObject?.PromoName}
                xOpen={promtionBasketOpen}
                xRows={filteredBasketRows}
                xRowsOrginal={basketRows}
                updateRows={setfilteredBasketRows}
                getBasketRows={getBasketRows}
                xModalfullScreen={vMediaQuery}
                xModalHeight={vMediaQuery ? "100vh" : "65vh"}
                vMediaQuery={vMediaQuery}
                xCloseModal={() => setPromtionBasketOpen(false)}
                xHeadSelectedLoc={headSelectedLocation}
                xOnChange={(value) => {
                  handleDetailChange("PromoName", value);
                }}
                xOnKeyUp={fPromotionSearchKey}
                xonClickbtn={fPromotionSearchKey}
                xRowClick={(params) => {
                  handleBasketRowClick(params);
                  setTimeout(() => {
                    const wrapper = document.querySelector('[tabindex="11"]');
                    const stockInput = wrapper?.querySelector(
                      "input.MuiInputBase-input"
                    );
                    stockInput?.focus();
                  }, 1000);
                }}
                xLocation={locationArr}
                xtabIndex={10}
                xOnKeyDown={(e) => {
                  if (
                    e.key === "Backspace" &&
                    (e.currentTarget.value ?? "").length <= 1
                  ) {
                    setBufferObj((prev) => ({
                      ...prev,
                      B_PromoId: "",
                      PromoName: e.target.value,
                    }));
                  }
                }}
              />
            </Grid>
            <Grid item xs={4} sm={3} md={isLessThanLarge ? 1 : 0.8}>
              <Typography> Stock</Typography>
              <TextField
                type="number"
                size="small"
                name="B_Stock"
                value={bufferObject?.B_Stock}
                onChange={(e) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    B_Stock: e.target.value,
                  }))
                }
                onFocus={fContent_Focus}
                onBlur={fContent_Blur}
                fullWidth
                sx={{
                  width: 60,
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                }}
                tabIndex={11}
              />
            </Grid>
          </>
        )}
        {/* Action Buttons */}
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          <Box
            display="flex"
            gap={2}
            sx={{ justifyContent: "space-between", flexWrap: "wrap" }}
          >
            {/* New Button */}
            <Button
              size="small"
              variant="contained"
              onClick={fNewHead}
              disabled={headData?.A_Status === "POST"}
            >
              New
            </Button>

            {/* Save Button */}
            <Button
              size="small"
              variant="contained"
              onClick={() => fSave(false, "Saved")}
              disabled={headData?.A_Status === "POST"}
            >
              Save
            </Button>

            {/* Approve Button */}
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                confirmAlert({
                  title: "Approval Confirmation",
                  message: "Are you want to Approve?",
                  buttons: [
                    {
                      className: "alertBtn",
                      label: "Yes",
                      onClick: () => fSave(true, "Approved"),
                    },
                    {
                      className: "alertBtn",
                      label: "No",
                    },
                  ],
                });
              }}
              disabled={headData?.A_Status === "POST"}
            >
              Approve
            </Button>

            {/* Reverse Button - Only when status is REJECT and not ENTER */}
            {headData?.A_StatusCM?.toUpperCase() === "REJECT" &&
              headData?.A_Status?.toUpperCase() !== "ENTER" && (
                <Button
                  size="small"
                  variant="contained"
                  color="error"
                  onClick={() => {
                    confirmAlert({
                      title: "Reverse Confirmation",
                      message: "Are you sure you want to Reverse?",
                      buttons: [
                        {
                          className: "alertBtn",
                          label: "Yes",
                          onClick: reverseSave,
                        },
                        {
                          className: "alertBtn",
                          label: "No",
                        },
                      ],
                    });
                  }}
                >
                  Reverse
                </Button>
              )}
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      {/* Data Grid Section */}
      <Box
        mt={2}
        sx={{
          height: {
            xs: "25vh",
            sm: "30vh",
            md: "40vh",
            lg: "47vh",
          },
          width: "100%",
        }}
      >
        <DataGridPro
          apiRef={apiRef}
          rowHeight={25}
          headerHeight={30}
          hideFooter
          rows={DetailData}
          getRowId={(v) => v.B_Srno}
          columns={[
            {
              field: "delete",
              headerName: "Action",
              width: 70,
              align: "center",
              hide:
                headData?.A_Status?.toUpperCase() === "ENTER" ? false : true,
              renderCell: (params) => (
                <DeleteIcon
                  style={{
                    cursor:
                      headData?.A_Status === "POST" ? "not-allowed" : "pointer",
                    color: headData?.A_Status === "POST" ? "gray" : "red",
                  }}
                  onClick={() => {
                    if (headData?.A_Status !== "POST") {
                      confirmAlert({
                        title: "Delete",
                        message: `Are you sure you want to delete this item ? ${params.row.ItemName}`,
                        buttons: [
                          {
                            label: "Yes",
                            onClick: () => handleDelete(params.row),
                          },
                          { label: "No" },
                        ],
                      });
                    }
                  }}
                />
              ),
            },
            {
              field: "B_Itmcd",
              headerName: "Item Code",
              width: 80,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "ItemName",
              headerName: "Item Name",
              headerAlign: "left",
              align: "left",
              width: 250,
            },

            {
              field: "UnitName",
              headerName: "Unit Name",
              width: 65,
              headerAlign: "left",
              align: "left",
            },

            {
              field: "B_CostPrice",
              headerName: "Cost Price",
              width: 60,
              headerAlign: "right",
              align: "right",
            },

            {
              field: "B_Old_RSP",
              headerName: "RSP",
              width: 60,
              headerAlign: "right",
              align: "right",
              cellClassName: (params) =>
                params.row.B_Old_RSP !== params.row.B_New_RSP ? "cell-old" : "",
            },
            {
              field: "B_Old_RSPVat",
              headerName: "VAT RSP",
              width: 60,
              headerAlign: "right",
              align: "right",
              cellClassName: (params) =>
                params.row.B_Old_RSPVat !== params.row.B_New_RSPVat
                  ? "cell-old"
                  : "",
            },
            {
              field: "B_Old_GPPerc",
              headerName: "GP %",
              width: 60,
              headerAlign: "center",
              align: "center",
              cellClassName: (params) =>
                params.row.B_Old_GPPerc !== params.row.B_New_GPPerc
                  ? "cell-old"
                  : "",
            },
            {
              field: "B_Old_MarkupPerc",
              headerName: "Markup %",
              width: 60,
              headerAlign: "right",
              align: "right",
              cellClassName: (params) =>
                params.row.B_Old_MarkupPerc !== params.row.B_New_MarkupPerc
                  ? "cell-old"
                  : "",
            },
            {
              field: "B_New_RSP",
              headerName: "RSP",
              width: 60,
              headerAlign: "right",
              align: "right",
              cellClassName: (params) =>
                params.row.B_Old_RSP !== params.row.B_New_RSP ? "cell-new" : "",
            },

            {
              field: "B_New_RSPVat",
              headerName: "VAT RSP",
              width: 60,
              headerAlign: "right",
              align: "right",
              cellClassName: (params) =>
                params.row.B_Old_RSPVat !== params.row.B_New_RSPVat
                  ? "cell-new"
                  : "",
            },

            {
              field: "B_New_GPPerc",
              headerName: "GP %",
              width: 60,
              headerAlign: "center",
              align: "center",
              cellClassName: (params) =>
                params.row.B_Old_GPPerc !== params.row.B_New_GPPerc
                  ? "cell-new"
                  : "",
            },

            {
              field: "B_New_MarkupPerc",
              headerName: "Markup %",
              width: 60,
              headerAlign: "right",
              align: "right",
              cellClassName: (params) =>
                params.row.B_Old_GPPerc !== params.row.B_New_MarkupPerc
                  ? "cell-new"
                  : "",
            },
            {
              field: "B_RefDocNo",
              headerName: "Ref Doc NO",
              width: 90,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "B_Narration",
              headerName: "Narration",
              width: 100,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "B_Type",
              headerName: "Type",
              width: 110,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "CompetitorName",
              headerName: "Competitor",
              width: 100,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "B_CompetitorPrice",
              headerName: "Competitor Price",
              width: 95,
              align: "center",
            },
            {
              field: "B_ExpireDate",
              headerName: "Expire Date",
              width: 90,
              align: "center",
              valueFormatter: ({ value }) => {
                if (
                  !value ||
                  moment(value).format("DD/MM/YYYY") === "Invalid date"
                ) {
                  return "";
                }

                const formatted = moment(value).format("DD/MM/YYYY");
                return formatted === "01/01/1900" ? "" : formatted;
              },
            },
            {
              field: "B_AgingDays",
              headerName: "Aging Days",
              width: 80,
              align: "center",
            },
            {
              field: "B_Stock",
              headerName: "Stocks",
              width: 60,
              headerAlign: "center",
              align: "center",
            },
            {
              field: "PromoName",
              headerName: "Promo",
              width: 150,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "Department",
              headerName: "Main Group",
              width: 120,
              align: "left",
              headerAlign: "left",
            },
            {
              field: "SubGrpName",
              headerName: "Sub Group",
              width: 150,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "CategoryName",
              headerName: "Category",
              width: 140,
              align: "left",
              headerAlign: "left",
            },
            {
              field: "BrandName",
              headerName: "Brand",
              width: 100,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "B_VendorName",
              headerName: "Supplier",
              width: 180,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "B_RejectDetail",
              headerName: "Reject Type ",
              width: 100,
              headerAlign: "left",
              align: "left",
            },
            {
              field: "B_RejectNarration",
              headerName: "Reject Narration ",
              width: 120,
              headerAlign: "left",
              align: "left",
            },
          ]}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          onRowClick={(params) => handleRowClick(params.row)}
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
              //  padding: "0px 2px",
            },
            "& .MuiDataGrid-cell": {
              // padding: "0px 2px",
              fontSize: "9px",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              fontSize: "9px",
            },
            "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders":
              {
                backgroundColor: "#0d73bb",
                color: "#fff",
              },
            "& .MuiDataGrid-pinnedColumnHeaders": {
              zIndex: 2,
              textAlign: "left",
            },
            "& .MuiDataGrid-pinnedColumns--left": {
              boxShadow: "4px 0 6px -4px rgba(37, 15, 15, 0.2)",
            },
          }}
          initialState={{
            pinnedColumns: !vMediaQuery
              ? { left: ["B_Itmcd", "ItemName", "UnitName"] }
              : {},
          }}
        />
      </Box>
    </Box>
  );
};

export default RSPChangeDetail;
